<template>
  <div
    id="order_invoice_logs_modal"
    class="modal fade"
  >
    <div
      class="modal-dialog"
      style="max-width: 900px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('invoicePaymentLogs.title') }}</h4>
          <button
            type="button"
            class="close"
            @click="closeModal('order_invoice_logs_modal')"
          >
            &times;
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('columns.amount') }}</th>
                <th>{{ $t('invoicePaymentLogs.paidAfterColumn') }}</th>
                <th>{{ $t('invoicePaymentLogs.remainingAfterColumn') }}</th>
                <th>{{ $t('columns.paymentMethod') }}</th>
                <th>{{ $t('columns.staff') }}</th>
                <th>{{ $t('columns.note') }}</th>
                <th>{{ $t('common.date') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(l, index) in logs"
                :key="l.order_invoice_log_id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ l.amount }}</td>
                <td>{{ l.paid_amount_after }}</td>
                <td>{{ l.remaining_after }}</td>
                <td>{{ l.payment_method }}</td>
                <td>{{ l.staff_name }}</td>
                <td>{{ l.note }}</td>
                <td>{{ l.log_date }}</td>
              </tr>
              <tr v-if="logs.length === 0">
                <td
                  colspan="8"
                  class="text-center"
                >
                  {{ $t('invoicePaymentLogs.noPaymentsRecordedYet') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="closeModal('order_invoice_logs_modal')"
          >
            {{ $t('common.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['logs', 'closeModal']
}
</script>



// WEBPACK FOOTER //
// src/components/orderInvoice/InvoicePaymentLogs.vue